/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuPrimaryItemFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu-primary-item/base-navigation-menu-primary-item.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {MenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/menu-item.fragment';

export const FullNavigationMenuPrimaryItemFragment = gql`
  ${BaseNavigationMenuPrimaryItemFragment}
  ${LinkFragment}
  ${MenuItemFragment}

  fragment FullNavigationMenuPrimaryItemFragment on NavigationMenuPrimaryItem {
    ...BaseNavigationMenuPrimaryItemFragment

    menuItemsCollection {
      items {
        __typename
        ... on MenuItem {
          ...MenuItemFragment
        }
      }
    }
    menuItemsCursorCollection {
      items {
        __typename
        ... on MenuItem {
          ...MenuItemFragment
        }
      }
    }
    promotionalLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    promotionalLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
